import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MaintenanceOrder } from '../models/maintenance-order';
import { User } from '../models/user';
import { Maintenance } from '../models/maintenance';

export interface OrderFilters {
  status:string,
  user:User,
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOrderService {

  constructor(private http:HttpClient) { }

  async getOrders(filters?:OrderFilters) : Promise<MaintenanceOrder[]> {
    if(filters) {

      let filter = "";

      if (filters.status && filters.user) {
        filter = "?status=" + filters.status + "&user=" + filters.user.id;
      } else if (filters.status) {
        filter = "?status=" + filters.status;
      } else if (filters.user) {
        filter = "?user=" + filters.user.id;
      }

      return this.http.get<MaintenanceOrder[]>('/api/maintenance/order' + filter)
        .toPromise();
    } else {
      return this.http.get<MaintenanceOrder[]>('/api/maintenance/order')
        .toPromise();
    }
  }

  async postOrder(order:MaintenanceOrder) : Promise<MaintenanceOrder> {
    return this.http.post<MaintenanceOrder>('/api/maintenance/order', order)
      .toPromise();
  }

  async deleteOrder(order:MaintenanceOrder) : Promise<void>{
    return this.http.get<void>('/api/maintenance/order/' + order.id + '/delete').toPromise();
  }

  getMaintenanceByOrder(orderId:number) : Promise<Maintenance[]> {
    return this.http.get<Maintenance[]>('/api/maintenance/order/' + orderId + '/maintenance')
      .toPromise();
  }
}
